import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import { CdxApiGatewayHttpService } from '../../shared/services/cdx-api-gateway-http.service';
import { Endpoints } from './endpoints';

@Injectable()
export class CancelExchangeService {
  private http = inject(CdxApiGatewayHttpService);

  cancelExchangeService(body: any): Observable<object> {
    return this.http.post(Endpoints.CANCEL_EXCHANGE_ENDPONT, JSON.stringify(body));
  }
}
